import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ev-tag',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ev-tag.component.html',
  styleUrls: ['./ev-tag.component.css', '../../common/scss/route-itinerary-common.scss'],
})
export class EvTagComponent implements OnInit {
  @Input() count: number = 1;
  constructor() {}

  ngOnInit(): void {}
}
